export const EVENT = {
  CLICK: "click",
  HOVER: "hover",
  SCROLL: "scroll",
};

export const CATEGORY = {
  LOGOUT: "logout",
  LOGO: "logo",
  AVATAR: "avatar",
  MASTER_CATALOGUE: "master_catalogue",
  CREATE_COLLECTION: "create_collection",
  COLLECTION_INSIGHTS: "collection_insights",
  RETURN: "return",
  ADD_PRODUCT: "add_product",
  ALGOLIA: "algolia",
};

export const DESCRIPTION = {
  LOGOUT_BUTTON: "logout button",
  LOGO_IMAGE: "logo image",
  LOGO_TEXT: "logo text",
  AVATAR_ICON: "avatar icon",
  AVATAR_POPOVER: "opened avatar popover",
  MASTER_CATALOGUE_CARD: "master catalogue card",
  MASTER_CATALOGUE_BUTTON: "master catalogue button",
  CREATE_COLLECTION_CARD: "create collection card",
  CREATE_COLLECTION_BUTTON: "create collection button",
  COLLECTION_INSIGHTS_CARD: "collection insights card",
  COLLECTION_INSIGHTS_BUTTON: "collection insights button",
  RETURN_TO_HOME: "return to home",
  RETURN_TO_MASTER_CATALOGUE: "return to master catalogue",
  RETURN_TO_CREATE_CATALOGUE: "return to master catalogue",
  RETURN_TO_PRODUCT_SELECTION: "return to product selection",
  ADD_PRODUCT_BUTTON: "add product button",
  ADD_PRODUCT_FINISH_BUTTON: "add product finish button",
  ADD_PRODUCT_NEXT_BUTTON: "add product next button",
  ADD_PRODUCT_FINISH_DISABLED_BUTTON: "add product finish disabled button",
  BASIC_DETAILS_SELECT_CATEGORIES: "basic details select categories",
  BASIC_DETAILS_INPUT_PRODUCT_ID: "basic details input product id",
  UPLOAD_IMAGE_UPLOADER: "upload image uploader",
  UPLOAD_IMAGE_MORE_BUTTON: "upload image more button",
  UPLOAD_IMAGE_DONE_BUTTON: "upload image done button",
  UPLOAD_IMAGE_PREVIEW: "upload image preview",
  UPLOAD_IMAGE_CONTAINER: "upload image container",
  UPLOAD_IMAGE_REMOVE: "upload image remove",
  PHOTO_GALLERY: "photo gallery",
  FIELD_RENDERER_INPUT_PRICE: "field renderer input price",
  FIELD_RENDERER_SELECT_PRICE_UNITS: "field renderer select price units",
  FIELD_RENDERER_SELECT_PRICE_CURRENCY: "field renderer select price currency",
  FIELD_RENDERER_INPUT_NAME: "field renderer input name",
  FIELD_RENDERER_SELECT_FIELDS_ONLY: "field renderer select fields only",
  FIELD_RENDERER_SELECT_INPUT_FIELDS: "field renderer select or input fields",
  FIELD_RENDERER_TEXTAREA_DESCRIPTION: "field renderer textarea description",
  INTERNAL_DETAILS_TOGGLE: "internal details toggle switch",
  PRODUCT_DETAILS_ADD_ANOTHER_PRODUCT_BUTTON: "product details add another product button",
  PRODUCT_DETAILS_GO_TO_BUTTON: "product details go to button",
  PRODUCT_DETAILS_DELETE_BUTTON: "product details delete button",
  PRODUCT_DETAILS_EDIT_BUTTON: "product details edit button",
  PRODUCT_DETAILS_IMAGE_CAROUSEL_IMAGE: "product details image carousel image",
  ADD_NEW_CATEGORY: "add new category modal opened",
  ADD_NEW_CATEGORY_SELECT_NAME: "add new category select name",
  ADD_NEW_CATEGORY_INPUT_NAME: "add new category input name",
  ADD_NEW_CATEGORY_ADD_NEW_ITEM: "add new category add new item",
  ADD_NEW_CATEGORY_DONE_BUTTON: "add new category done button",
  CATEGORIES: "categories",
  EACH_CATEGORY_CARD_OPENED: "each category card opened",
  EACH_CATEGORY_CARD_FIRST_IMAGE: "each category card first image",
  EACH_CATEGORY_CARD_SECOND_IMAGE: "each category card second image",
  EACH_CATEGORY_CARD_THIRD_IMAGE: "each category card third image",
  CATEGORY_WISE_PRODUCT_ADD_PRODUCT_BUTTON: "category wise product add product button",
  CATEGORY_WISE_PRODUCT_CARD: "category wise product card",
  CATEGORY_WISE_PRODUCT_DELETE_BUTTON: "category wise product delete button",
  CATEGORY_WISE_PRODUCT_DELETE_CONFIRM: "category wise product delete confirm",
  CATEGORY_WISE_PRODUCT_EDIT_BUTTON: "category wise product edit button",
  CATEGORY_WISE_PRODUCT_MODAL_OPENED: "category wise product modal opened",
  CATEGORY_WISE_PRODUCT_MODAL_CLOSED: "category wise product modal closed",
  ALL_PRODUCTS: "all products",
  ALGOLIA_SELECT_SORTBY: "algolia select sort by",
  ALGOLIA_CLEAR_ALL_BUTTON: "algolia clear all button",
  ALGOLIA_SEARCH: "algolia search",
  ALGOLIA_CLOSE_SEARCH: "algolia close search",
  ALGOLIA_FILTER_CHECKED: "algolia filter checked",
  CREATE_COLLECTION_BUYER_COMPANY_NAME: "create collection buyer company name",
  CREATE_COLLECTION_CATALOGUE_NAME: "create collection catalogue name",
  CREATE_COLLECTION_BUYER_EMAIL: "create collection buyer email",
  CREATE_COLLECTION_NEXT_BUTTON: "create collection next button",
  CREATE_COLLECTION_VIEW_BUTTON: "create collection view button",
  CREATE_COLLECTION_SELECT_PRODUCT_CHECKED: "create collection select product checked",
  BUYER_VIEW_CHECKED: "buyer view checked",
  BUYER_VIEW_DONE_BUTTON: "buyer view done button",
  BUYER_VIEW_NEXT_BUTTON: "buyer view next button",
  VIEW_COLLECTION_TOGGLE_PRODUCT_COST: "view collection toggle product cost",
  VIEW_COLLECTION_ADD_MORE_PRODUCTS_BUTTON: "view collection add more products button",
  VIEW_COLLECTION_CUSTOMER_BUYER_VIEW_BUTTON: "view collection customer buyer view button",
  VIEW_COLLECTION_CONTINUE_BUTTON: "view collection continue button",
  VIEW_COLLECTION_SEND_FOR_APPROVAL: "view collection send for approval",
  VIEW_COLLECTION_GENERATE_CATALOGUE: "view collection generate catalogue",
  VIEW_COLLECTION_ADD_PRODUCT_BUTTON: "view collection add product button",
  SEND_FOR_APPROVAL_INPUT_EMAIL: "send for approval input email",
  SEND_FOR_APPROVAL_BUTTON: "send for approval button",
  SAVE_AS_DRAFT_BUTTON: "save as draft button",
  GENERATE_CATALOGUE_INPUT_COMPANY_NAME: "generate catalogue input company name",
  GENERATE_CATALOGUE_INPUT_CATALOGUE_NAME: "generate catalogue input catalogue name",
  GENERATE_CATALOGUE_INPUT_EMAIL: "generate catalogue input email",
  GENERATE_CATALOGUE_PREVIEW_BUTTON: "generate catalogue preview button",
  GENERATE_CATALOGUE_GENERATE_BUTTON: "generate catalogue generate catalogue button",
  ACTIVITY_HISTORY_EDIT_CATALOGUE: "activiy history edit catalogue",
  ACTIVITY_HISTORY_DOWNLOAD_EXCEL: "activity history download excel",
  ACTIVITY_HISTORY_DOWNLOAD_PDF: "activity history download pdf",
  ACTIVITY_HISTORY_COLLECTION_LINK_COPIED: "activity history collection link copied",
};